export const appendToFormData = (data: FormData, field: string, value: any) => {
    if (value === true) {
        value = 1;
    } else if (value === false) {
        value = 0;
    } else if (value === null) {
        value = "";
    }

    if ((Array.isArray(value) || (typeof value === 'object' && !(value instanceof File))) && value !== undefined && value !== null) {
        if (Array.isArray(value)) {
            value.filter(value => {
                if (typeof value === 'string' && value.trim() === '') {
                    return false;
                }
                
                return true;
            }).forEach((value, key) => {
                appendToFormData(data, field + '[' + key + ']', value);
            });
        } else {
            Object.keys(value).forEach(key => {
                if (Array.isArray(value[key]) || typeof value[key] === 'object') {
                    appendToFormData(data, field + '[' + key + ']', value[key]);
                } else {
                    let val = value[key];
                    if (value[key] === true) {
                        val = 1;
                    } else if (value[key] === false) {
                        val = 0;
                    } else if (value[key] === null) {
                        val = "";
                    }

                    data.append(field + '[' + key + ']', val)
                }
            });
        }
    } else {
        data.append(field, value);
    }

    return data;
};
